// Quality Assurance page English translations

export default {
  pageTitle: "Quality Assurance",
  breadcrumbHome: "Home",
  breadcrumbServices: "Services",
  breadcrumbCurrent: "Quality Assurance",
  
  // Service links
  customManufacturing: "Custom Manufacturing",
  technicalSupport: "Technical Support",
  afterSalesService: "After-Sales Service",
  qualityAssurance: "Quality Assurance",
  researchDevelopment: "Research & Development",
  globalSupplyChain: "Global Supply Chain",
  
  // Main content
  title: "Rigorous Quality Assurance System",
  description1: "At PT Eagle Industry Indonesia, quality is the foundation of everything we do. Our comprehensive quality assurance system ensures that every product leaving our facility meets the highest international standards and customer specifications. We are committed to delivering excellence through systematic quality control processes and continuous improvement initiatives.",
  description2: "Our quality management system is certified under ISO 9001 standards, demonstrating our commitment to consistent quality and customer satisfaction. This framework guides our processes from raw material selection to final product delivery, ensuring reliability and performance in every component we manufacture.",
  
  // Framework section
  frameworkTitle: "Our Quality Assurance Framework:",
  framework: [
    "ISO 9001:2015 certified quality management system",
    "Comprehensive incoming material inspection and verification",
    "In-process quality control at critical manufacturing stages",
    "Advanced metrology and precision measurement capabilities",
    "Statistical process control for manufacturing consistency",
    "Final product testing and performance validation",
    "Traceability systems for complete product lifecycle tracking"
  ],
  
  // Testing capabilities section
  testingTitle: "Testing and Inspection Capabilities:",
  testingDescription: "Our quality assurance is supported by state-of-the-art testing facilities and highly trained quality professionals. We employ advanced inspection techniques including coordinate measuring machines, non-destructive testing, material analysis, and performance testing under simulated operating conditions. These capabilities ensure that our products perform reliably in real-world applications.",
  
  // Metrics
  qualityStandards: "Quality Standards",
  qualityStandardsDesc: "Compliance with international standards and certifications",
  inspectionTechnology: "Inspection Technology",
  inspectionTechnologyDesc: "Advanced metrology equipment for precise measurements",
  processControl: "Process Control",
  processControlDesc: "Statistical methods ensuring manufacturing consistency",
  continuousImprovement: "Continuous Improvement",
  continuousImprovementDesc: "Regular system reviews and enhancement initiatives",
  
  // Certifications section
  certificationsTitle: "Quality Certifications:",
  certificationsDescription: "In addition to our ISO 9001 certification, we maintain various industry-specific quality certifications that demonstrate our commitment to excellence. These include ISO 14001 for environmental management and ISO 45001 for occupational health and safety, reflecting our holistic approach to quality that encompasses product performance, environmental responsibility, and workplace safety.",
  
  // Customer QA section
  customerQATitle: "Customer Quality Assurance:",
  customerQADescription: "We work closely with our customers to understand their specific quality requirements and develop customized quality assurance protocols. Our customer quality assurance team provides detailed quality documentation, certificates of conformity, and traceability records to ensure complete transparency and confidence in our products.",
  
  // Supplier QA section
  supplierQATitle: "Supplier Quality Management:",
  supplierQADescription: "Our quality assurance extends to our supply chain through rigorous supplier qualification and monitoring programs. We work only with suppliers who meet our stringent quality standards and conduct regular audits to ensure consistent quality in all materials and components sourced from external partners.",
  
  // CTA button
  learnMore: "Learn About Our Quality Standards",
  
  // Related services section
  relatedServicesTitle: "Related Services",
  relatedServicesDescription: "Explore our other comprehensive services",
  customManufacturingDesc: "Tailored manufacturing solutions to meet specific customer requirements.",
  afterSalesServiceDesc: "Comprehensive after-sales support to ensure customer satisfaction.",
  researchDevelopmentDesc: "Continuous innovation to develop advanced sealing solutions.",
  readMore: "Read more"
};